import { useMutation } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestUpdateMerchantPrice } from "./updateMerchantPrice.request";
import { UpdateMerchantPriceResponse } from "./updateMerchantPrice.types";

const useUpdateMerchantPrice = (
  options?: MutationOptions<
    UpdateMerchantPriceResponse,
    ApiServiceError<ApiError>
  >
) => {
  return useMutation({
    mutationFn: requestUpdateMerchantPrice,
    onError: toastServerError,
    ...options
  });
};

export default useUpdateMerchantPrice;
